
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'

@Component
export default class LazyImage extends Vue {
  @Prop()
    src: string

  @Prop({ default: '' })
    srcset: string

  @Prop({ default: true })
    lazy: boolean

  get imgAttrs() {
    if (this.lazy) {
      return {
        loading: 'lazy',
        src: this.src,
        srcset: this.srcset,
      }
    }
    return {
      src: this.src,
      srcset: this.srcset,
    }
  }
}
